<template>
  <b-row class="match-height">
    <b-col lg="12">
      <b-card title="Confirm Purchase Request By Vice President">
        <b-form @submit.prevent="submitConfirmPurchaseRequest">
          <b-row>
            <b-col cols="12">
              <b-button
                type="button"
                variant="primary"
                class="mr-1"
                @click="previous()"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  size="16"
                  class="align-middle"
                />
                Back
              </b-button>
              <div class="devider" />
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Number"
                label-for="purchase_request_number"
                label-cols-md="12"
              >
                <b-form-input
                  id="purchase_request_number"
                  v-model="purchaseRequestNumber"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Class"
                label-for="purchase_request_class"
                label-cols-md="12"
              >
                <b-form-input
                  id="chosenClass"
                  v-model="chosenClass"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Project"
                label-for="purchase_request_project"
                label-cols-md="12"
              >
                <b-form-input
                  id="purchase_request_project"
                  v-model="purchaseRequestProject"
                  placeholder="Project"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Cost Center"
                label-for="purchase_request_cost_center"
                label-cols-md="12"
              >
                <b-form-input
                  id="chosenBranch"
                  v-model="chosenBranch"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Type"
                label-for="purchase_request_type"
                label-cols-md="12"
              >
                <b-form-input
                  id="purchase_request_type"
                  v-model="purchaseRequestType"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Deliver To"
                label-for="purchase_request_deliver_to"
                label-cols-md="12"
              >
                <b-form-input
                  id="deliverTo"
                  v-model="purchaseRequestDeliverTo"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Need For"
                label-for="purchase_request_need_for"
                label-cols-md="12"
              >
                <b-form-input
                  id="purchase_request_need_for"
                  v-model="purchaseRequestNeedFor"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Category"
                label-for="purchase_request_category"
                label-cols-md="12"
              >
                <b-form-input
                  id="purchase_request_category"
                  v-model="purchaseRequestCategory"
                  readonly
                />
              </b-form-group>
              <b-form-group
                label="Notes"
                label-for="purchase_request_notes"
                label-cols-md="12"
              >
                <b-form-input
                  id="purchase_request_notes"
                  v-model="purchaseRequestNotes"
                  placeholder="Notes"
                  readonly
                />
              </b-form-group>
              <b-form-group
                v-if="purchaseRequestCategory == 'Assets' && purchaseRequestAssetCategory != ''"
                label="Asset Category"
                label-for="purchase_request_asset_category"
                label-cols-md="12"
              >
                <b-form-input
                  v-if="purchaseRequestCategory == 'Assets' && purchaseRequestAssetCategory != ''"
                  id="purchase_request_asset_category"
                  v-model="purchaseRequestAssetCategory"
                  placeholder="Notes"
                  readonly
                />
              </b-form-group>
            <b-row>
              <b-col
                cols="3"
                class="text-center font-weight-bold"
              >
                Item name
              </b-col>
              <b-col
                cols="2"
                class="text-center font-weight-bold"
              >
                MR Number
              </b-col>
              <b-col
                cols="1"
                class="text-center font-weight-bold"
              >
                Unit name
              </b-col>
              <b-col
                cols="2"
                class="text-center font-weight-bold"
              >
                Item QTY Requested
              </b-col>
              <b-col
                cols="2"
                class="text-center font-weight-bold"
              >
                Item QTY Accepted
              </b-col>
              <b-col
                cols="1"
                class="text-center font-weight-bold"
              >
                Balance
              </b-col>
              <b-col
                cols="1"
                class="text-center font-weight-bold"
              >
                Avg Req / Monthly
              </b-col>
            </b-row>
            <p />
            <b-row
              v-for="chosen in chosens"
              :key="chosen.value"
            >
              <br>
              <b-col cols="3 text-center">
                <b-list-group>
                  <b-list-group-item href="#">
                    {{ chosen.label }}
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="2 text-center">
                <b-list-group>
                  <b-list-group-item href="#">
                    {{ capitalizeWords(chosen.mr_number) }}
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="1 text-center">
                <b-list-group>
                  <b-list-group-item href="#">
                    {{ capitalizeWords(chosen.unit_name) }}
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="2 text-center">
                <b-form-input
                  v-model="chosen.qty_requested"
                  type="number"
                  placeholder="Qty Requested"
                  :max="chosen.qty_requested"
                  readonly
                />
              </b-col>
              <b-col cols="2 text-center">
                <b-form-input
                  v-model="chosen.qty_accepted"
                  type="number"
                  placeholder="Qty Accepted"
                  :max="chosen.qty_accepted"
                  readonly
                />
              </b-col>
              <b-col cols="1 text-center">
                <b-form-input
                  v-model="chosen.balance"
                  placeholder="Balance"
                  :max="chosen.balance"
                  readonly
                />
              </b-col>
              <b-col cols="1 text-center">
                <b-form-input
                  v-model="chosen.avg"
                  placeholder="Avg Req"
                  :max="chosen.avg"
                  readonly
                />
              </b-col>
              <b-col cols="12">
                <br>
              </b-col>
            </b-row>
            <b-form-group>
              <label for="no_invoice">Status :</label>
              <vue-horizontal-timeline :items="statusItems" />
            </b-form-group>
            </b-col>
            <b-col offset-md="12">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
                :disabled="submitButtonDisabled"
              >
                Confirm
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import Ripple from 'vue-ripple-directive'
import { VueHorizontalTimeline } from 'vue-horizontal-timeline'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BListGroup,
    BListGroupItem,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    VueHorizontalTimeline,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      submitButtonDisabled: false,
      purchaseRequestNumber: '',
      purchaseRequestType: '',
      purchaseRequestClass: '',
      purchaseRequestProject: '',
      purchaseRequestCostCenter: '',
      purchaseRequestQtyRequested: 0,
      purchaseRequestStatus: '',
      purchaseRequestNotes: '',
      purchaseRequestDeliverTo: '',
      purchaseRequestNeedFor: '',
      purchaseRequestCategory: '',
      purchaseRequestAssetCategory: '',
      purchaseRequestIsConfirmed: false,
      purchaseRequestIsConfirmedByFACoalManager: false,
      isCenter: false,
      isVisiblePrint: false,
      chosenBranch: '',
      chosenClass: '',
      statusItems: [],
      items: [],
      chosenItem: null,
      chosens: [],
      VersionCheck: '',
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
  capitalizeWords(str) {
      const words = str.split(' ')
      const capitalizedWords = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      return capitalizedWords.join(' ')
    },
    dateSimple(value, format = 'YYYY-MM-DD') {
      let dateRet = ''
      if (value !== null) {
        dateRet = moment.utc(value).tz('Asia/Jakarta').format(format)
      } else {
        dateRet = null
      }
      return dateRet
    },

    getDetails() {
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      const id = localStorage.getItem('purchaseRequestDetailsId')

      axios
        .get(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_PURCHASE_REQUESTS_DETAILS}${id}`,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            axios
              .get(
                `${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_PURCHASE_REQUESTS_SINGLE}${id}`,
                { headers },
              )
              .then(response2 => {
                if (response2.data.success === true && response2.data.data) {
                  const { data } = response2.data
                  const assetCategory = response.data.data.purchase_request_asset_category

                  this.chosenClass = data.purchase_request_class
                  this.purchaseRequestProject = data.purchase_request_project

                  const branchCity = data.cost_center ? data.cost_center.branch_city : '-'
                  const branchCode = data.cost_center ? data.cost_center.branch_code : '-'
                  this.chosenBranch = `${branchCity} (${branchCode})`

                  this.purchaseRequestNotes = data.purchase_request_notes
                  this.purchaseRequestAssetCategory = assetCategory !== null && typeof assetCategory !== 'undefined'
                    ? assetCategory
                    : ''

                  this.purchaseRequestType = data.purchase_request_is_center === true ? 'Headoffice' : 'Cabang'
                  this.isCenter = data.purchase_request_is_center
                  this.purchaseRequestIsConfirmedByFACoalManager = data.purchase_request_is_confirmed_by_fa_coal_manager !== null
                  this.purchaseRequestNumber = data.purchase_request_number
                  this.purchaseRequestIsConfirmed = data.purchase_request_is_confirmed !== null
                  this.purchaseRequestNeedFor = data.purchase_request_need_for
                  this.purchaseRequestCategory = data.purchase_request_category
                  this.purchaseRequestDeliverTo = data.purchase_request_deliver_to

                  if (data.purchase_request_category === 'Supplies' && data.purchase_request_is_center === false) {
                    if (data.purchase_request_is_confirmed_by_laboratory_manager !== null) {
                      this.isVisiblePrint = true
                    }
                  } else if (
                    data.purchase_request_is_center === false
                    && (data.purchase_request_category === 'Assets' || data.purchase_request_category === 'FGS')
                  ) {
                    if (data.purchase_request_is_confirmed_by_fa_coal_manager !== null) {
                      this.isVisiblePrint = true
                    }
                  } else if (data.purchase_request_is_center === true) {
                    if (data.purchase_request_is_confirmed_by_fa_coal_manager !== null) {
                      this.isVisiblePrint = true
                    }
                  }

                  let obj1
                  let obj2
                  let obj3
                  let obj4
                  let obj5
                  let obj6
                  let obj7
                  let obj8

                  this.statusItems = []

                  if (data.purchase_request_is_center === true) {
                    obj1 = {
                      title: 'Created',
                      content: `Purchase Request Has been Created By ${data.creator.user_fullname} at ${this.dateSimple(data.purchase_request_created_time, 'YYYY-MM-DD')}`,
                      stepCssClass: 'has-step-green',
                      boxCssClass: 'has-color-red',
                    }
                    obj2 = {
                      title: 'Laboratory Manager',
                      content: data.purchase_request_is_confirmed_by_laboratory_manager !== null
                        ? `Purchase Request Has been Accepted by ${data.laboratory_manager.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_laboratory_manager_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Accepted By Laboratory Manager',
                      stepCssClass: data.purchase_request_is_confirmed_by_laboratory_manager !== null ? 'has-step-green' : 'has-step-red',
                    }
                    obj3 = {
                      title: 'Regional Manager',
                      content: data.purchase_request_is_confirmed_by_regional_manager !== null
                        ? `Purchase Request Has been Confirmed By Regional Manager at ${this.dateSimple(data.purchase_request_is_confirmed_by_regional_manager_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Confirmed by Regional Manager',
                      stepCssClass: data.purchase_request_is_confirmed_by_regional_manager !== null ? 'has-step-green' : 'has-step-red',
                    }
                    obj4 = {
                      title: 'Division Head',
                      content: data.purchase_request_is_confirmed_by_division_head !== null
                        ? `Purchase Request Has been Confirmed By Division Head at ${this.dateSimple(data.purchase_request_is_confirmed_by_division_head_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Confirmed by Division Head',
                      stepCssClass: data.purchase_request_is_confirmed_by_division_head !== null ? 'has-step-green' : 'has-step-red',
                    }
                    obj5 = {
                      title: 'FA Coal Manager',
                      content: data.purchase_request_is_confirmed_by_fa_coal_manager !== null
                        ? `Purchase Request Has been Confirmed By FA Coal Manager at ${this.dateSimple(data.purchase_request_is_confirmed_by_fa_coal_manager_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Confirmed by FA Coal Manager',
                      stepCssClass: data.purchase_request_is_confirmed_by_fa_coal_manager !== null ? 'has-step-green' : 'has-step-red',
                    }
                    obj6 = {
                      title: 'Operation Director',
                      content: data.purchase_request_is_confirmed_by_operation_director !== null
                        ? `Purchase Request Has been Confirmed By Operation Director at ${this.dateSimple(data.purchase_request_is_confirmed_by_operation_director_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Confirmed by Operation Director',
                      stepCssClass: data.purchase_request_is_confirmed_by_operation_director !== null ? 'has-step-green' : 'has-step-red',
                    }
                    obj7 = {
                      title: 'Vice President',
                      content: data.purchase_request_is_confirmed_by_vice_president !== null
                        ? `Purchase Request Has been Confirmed By Vice President at ${this.dateSimple(data.purchase_request_is_confirmed_by_vice_president_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Confirmed by Vice President',
                      stepCssClass: data.purchase_request_is_confirmed_by_vice_president !== null ? 'has-step-green' : 'has-step-red',
                    }
                    obj8 = {
                      title: 'President Director',
                      content: data.purchase_request_is_confirmed_by_president_director !== null
                        ? `Purchase Request Has been Confirmed By President Director at ${this.dateSimple(data.purchase_request_is_confirmed_by_president_director_time, 'YYYY-MM-DD')}`
                        : 'Purchase Request Has not been Confirmed by President Director',
                      stepCssClass: data.purchase_request_is_confirmed_by_president_director !== null ? 'has-step-green' : 'has-step-red',
                    }

                    this.statusItems.push(obj1, obj2, obj3, obj4, obj5, obj6, obj7, obj8)
                  } else {
                    if (data.purchase_request_category === 'Assets' || data.purchase_request_category === 'FGS') {
                      obj1 = {
                        title: 'Created',
                        content: `Purchase Request Has been Created By ${data.creator.user_fullname} at ${this.dateSimple(data.purchase_request_created_time, 'YYYY-MM-DD')}`,
                        stepCssClass: 'has-step-green',
                        boxCssClass: 'has-color-red',
                      }
                      obj2 = {
                        title: 'Purchasing Cabang',
                        content: data.purchase_request_is_confirmed_by_purchasing_cabang !== null
                          ? `Purchase Request Has been Accepted by ${data.purchasing_cabang.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_purchasing_cabang_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By Purchasing Cabang',
                        stepCssClass: data.purchase_request_is_confirmed_by_purchasing_cabang !== null ? 'has-step-green' : 'has-step-red',
                      }
                      obj3 = {
                        title: 'Laboratory Manager',
                        content: data.purchase_request_is_confirmed_by_laboratory_manager !== null
                          ? `Purchase Request Has been Accepted by ${data.laboratory_manager.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_laboratory_manager_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By Laboratory Manager',
                        stepCssClass: data.purchase_request_is_confirmed_by_laboratory_manager !== null ? 'has-step-green' : 'has-step-red',
                      }
                      obj4 = {
                        title: 'Regional Manager',
                        content: data.purchase_request_is_confirmed_by_regional_manager !== null
                          ? `Purchase Request Has been Accepted by ${data.regional_manager.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_regional_manager_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By Regional Manager',
                        stepCssClass: data.purchase_request_is_confirmed_by_regional_manager !== null ? 'has-step-green' : 'has-step-red',
                      }
                      obj5 = {
                        title: 'Division Head',
                        content: data.purchase_request_is_confirmed_by_division_head !== null
                          ? `Purchase Request Has been Accepted by ${data.division_head.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_division_head_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By Division Head',
                        stepCssClass: data.purchase_request_is_confirmed_by_division_head !== null ? 'has-step-green' : 'has-step-red',
                      }
                      obj6 = {
                        title: 'FA Coal Manager',
                        content: data.purchase_request_is_confirmed_by_fa_coal_manager !== null
                          ? `Purchase Request Has been Accepted by ${data.fa_coal_manager.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_fa_coal_manager_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By FA Coal Manager',
                        stepCssClass: data.purchase_request_is_confirmed_by_fa_coal_manager !== null ? 'has-step-green' : 'has-step-red',
                      }

                      this.statusItems.push(obj1, obj2, obj3, obj4, obj5, obj6)
                    } else {
                      obj1 = {
                        title: 'Created',
                        content: `Purchase Request Has been Created By ${data.creator.user_fullname} at ${this.dateSimple(data.purchase_request_created_time, 'YYYY-MM-DD')}`,
                        stepCssClass: 'has-step-green',
                        boxCssClass: 'has-color-red',
                      }
                      obj2 = {
                        title: 'Purchasing Cabang',
                        content: data.purchase_request_is_confirmed_by_purchasing_cabang !== null
                          ? `Purchase Request Has been Accepted by ${data.purchasing_cabang.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_purchasing_cabang_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By Purchasing Cabang',
                        stepCssClass: data.purchase_request_is_confirmed_by_purchasing_cabang !== null ? 'has-step-green' : 'has-step-red',
                      }
                      obj3 = {
                        title: 'Laboratory Manager',
                        content: data.purchase_request_is_confirmed_by_laboratory_manager !== null
                          ? `Purchase Request Has been Accepted by ${data.laboratory_manager.user_fullname} at ${this.dateSimple(data.purchase_request_is_confirmed_by_laboratory_manager_time, 'YYYY-MM-DD')}`
                          : 'Purchase Request Has not been Accepted By Laboratory Manager',
                        stepCssClass: data.purchase_request_is_confirmed_by_laboratory_manager !== null ? 'has-step-green' : 'has-step-red',
                      }

                      this.statusItems.push(obj1, obj2, obj3)
                    }
                  }
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Get Data Failed',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                    },
                  })
                }
              })

            const itemsJoin = []
            response.data.data.map(elem => {
              itemsJoin.push({
                label: `${elem.item.item_name} (${elem.item.item_code})`,
                unit_name: `${elem.item.unit ? elem.item.unit.unit_name : '-'}`,
                mr_number: `${elem.material_request ? elem.material_request.material_request_number : '-'}`,
                value: elem.purchase_request_detail_id,
                qty_requested: elem.purchase_request_detail_item_qty_requested,
                qty_accepted: elem.purchase_request_detail_item_qty_accepted,
                avg: elem.purchase_request_detail_item_avg,
                balance: elem.purchase_request_detail_item_balance,
              })
            })
            this.chosens = itemsJoin
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Get Data Failed',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(e => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Get Data Failed',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    submitConfirmPurchaseRequest() {
      this.submitButtonDisabled = true
      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userToken}`,
      }
      const id = localStorage.getItem('purchaseRequestDetailsId')
      const body = {
        time: moment(),
      }
      const url = `${process.env.VUE_APP_API_URL}transactions/purchase_requests/confirm/center`

      axios
        .post(`${url}/vice_president/${id}`, body, { headers })
        .then(response => {
          this.submitButtonDisabled = false
          if (response.data.success === true) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase Request Success',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.replace({ name: 'apps-procurement-purchase-request-list' })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Something went wrong',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(() => {
          this.submitButtonDisabled = false
        })
    },

    getOptionLabel(option) {
      return (option && option.label) || ''
    },

    putItem(val) {
      if (this.chosens.length > 0) {
        let same = false
        this.chosens.map(elem => {
          if (elem.value === val.value) {
            same = true
          }
        })
        if (same === false) {
          let item = null
          this.items.map(elem => {
            if (elem.value === val.value) {
              item = {
                unit_name: elem.unit_name,
                label: elem.label,
                value: elem.value,
                qty: 1,
              }
            }
          })
          this.chosens.push(item)
        }
      } else {
        let item = null
        this.items.map(elem => {
          if (elem.value === val.value) {
            item = {
              unit_name: elem.unit_name,
              label: elem.label,
              value: elem.value,
              qty: 1,
            }
          }
        })
        this.chosens.push(item)
      }
    },

    applyItem(val) {

    },

    getOptionKey(option) {
      return (option && option.value) || ''
    },

    inputSearch(search) {

    },

    removeRow(val) {
      this.chosens = this.chosens.filter(obj => obj.value !== val)
    },

    dateFormat(value, format = 'MM/DD/YYYY') {
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    },

    previous() {
      this.$router.push({ name: 'apps-procurement-purchase-request-list' })
    },
  },
}
</script>
